import React, { useState, useEffect } from 'react';
import './Carousel.css';

const images = [
    require('../assets/banner1.jpg'),
    require('../assets/banner2.jpg'),
    require('../assets/banner3.jpg')
];

const bannerText = [
    "Love and Care for Every Paw",
    "Adopt, Don't Shop",
    "Give a Pet a Second Chance"
]

const Carousel = () => {
    const [slideIndex, setSlideIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setSlideIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 7000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="slideshow-container">
            <div className="slides" style={{ transform: `translateX(-${slideIndex * 100}%)` }}>
                {images.map((image, index) => (
                    <div key={index} className="slide">
                        <div className="numbertext">{index + 1} / {images.length}</div>
                        <img src={image} style={{ width: '100%' }} alt={`Slide ${index + 1}`} />
                        {/* <div className="text">
                            <h1 className='bannerText'>{bannerText[index]}</h1>
                        </div> */}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Carousel;